import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

export default ({ isLoading, text, loadingText, className = 'btn-primary', disabled = false, ...props }) => (
	<Button className={`LoaderButton ${className}`} disabled={disabled || isLoading} {...props}>
		{isLoading && <Glyphicon glyph="refresh" className="spinning" />}
		{!isLoading ? text : loadingText}
	</Button>
);